import { apiClient } from "../../lib/http/apiClient";
import type { BusinessContactCreatePayload, BusinessContactResponse } from "./types";

export const contactsService = {
  async createContact(payload: BusinessContactCreatePayload): Promise<BusinessContactResponse> {
    const { data } = await apiClient.post<BusinessContactResponse>("/api/contacts", payload);
    return data;
  },

  async listMyContacts(): Promise<{
    items: BusinessContactResponse[];
    total: number;
    skip: number;
    limit: number;
    has_more: boolean;
  }> {
    const { data } = await apiClient.get<{
      items: BusinessContactResponse[];
      total: number;
      skip: number;
      limit: number;
      has_more: boolean;
    }>("/api/contacts/my", {
      params: { skip: 0, limit: 200 },
    });
    return data;
  },

  async listContacts(skip = 0, limit = 100, organizationType?: string): Promise<BusinessContactResponse[]> {
    const { data } = await apiClient.get<BusinessContactResponse[]>("/api/contacts", {
      params: { skip, limit, ...(organizationType ? { organization_type: organizationType } : {}) },
    });
    return data ?? [];
  },
};
